var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-form-dialog",
        {
          ref: "payerInfoDialog",
          attrs: {
            top: "15vh",
            btnRightText: "提交订单",
            "form-option-num-temp": "6",
            "is-form": "",
            title: "付款人信息",
            width: "45%",
          },
          on: { onClickRight: _vm.onSubmitResult },
        },
        [
          _c("template", { slot: "form_bottom" }, [
            _c(
              "div",
              { staticStyle: { "margin-left": "20px" } },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.insureFirst,
                      callback: function ($$v) {
                        _vm.insureFirst = $$v
                      },
                      expression: "insureFirst",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t本人确认已获得上述投保企业授权支付保费，若发生退费，原路返还至交款账户\n\t\t\t\t"
                    ),
                  ]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-top": "5px" },
                    model: {
                      value: _vm.insureSecond,
                      callback: function ($$v) {
                        _vm.insureSecond = $$v
                      },
                      expression: "insureSecond",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t我已仔细阅读并同意《保险条款》《投保须知》等内容\n\t\t\t\t"
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "center",
                  "margin-top": "40px",
                  "margin-bottom": "20px",
                },
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-right": "20px", width: "100px" },
                    attrs: { plain: "", type: "primary" },
                    on: { click: _vm.onCancel },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "20px", width: "100px" },
                    attrs: { loading: _vm.isSubmitLoading, type: "primary" },
                    on: { click: _vm.onSubmit },
                  },
                  [_vm._v("\n\t\t\t\t\t提交订单\n\t\t\t\t")]
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }